import type { initialStageAvatarStateType } from "src/reducks/AvatarStageStore/types";

export const initialStageAvatarState: initialStageAvatarStateType = {
  stageImage: "",
};
